/* FGR4 / V11 — customer review carousel. Native CSS scroll-snap remains usable without JS. */
(() => {
 'use strict';
 if (window.__fgr4CustomerVoicesAttached) return;
 window.__fgr4CustomerVoicesAttached = true;
 document.addEventListener('click', event => {
   const control = event.target.closest('[data-f11-prev], [data-f11-next]');
   if (!control) return;
   const region = control.closest('.f11-voices');
   const rail = region?.querySelector('[data-f11-rail]');
   const card = rail?.querySelector('.f11-voices__card');
   if (!rail || !card) return;
   const gap = Number.parseFloat(getComputedStyle(rail).gap) || 13;
   const amount = card.getBoundingClientRect().width + gap;
   const delta = amount * (control.hasAttribute('data-f11-next') ? 1 : -1);
   rail.scrollBy({left: delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
 });
})();